export default {
  Meeting: {
    Schedule: 'Thời khóa biểu',
    Meetings: 'Lịch học',
    Detail: 'Chi tiết',
    JoinClass: 'Vào lớp',
    Teacher: 'Giáo viên: ',
    Subject: 'Môn: ',
    Duration: 'Thời lượng: ',
    Class: 'Lớp: ',
    Happenning: 'Đang diễn ra',
    LeftTime: 'Còn ',
    DurationMinuteDetail: '{timeMinute} phút',
    DurationHourDetail: '{timeHour} giờ',
    DurationHourMinuteDetail: '{timeHour} giờ {timeMinute} phút',
    Monday: 'Thứ 2',
    Tuesday: 'Thứ 3',
    Wednesday: 'Thứ 4',
    Thursday: 'Thứ 5',
    Friday: 'Thứ 6',
    Saturday: 'Thứ 7',
    Sunday: 'Chủ nhật',
    TeacherTitle: 'Giáo viên:',
    SubjectTitle: 'Môn:',
    ClassTitle: 'Lớp:',
    MeetingRoom: 'Phòng:',
    StartTime: 'Thời gian:',
    DurationTitle: 'Thời lượng:',
    Description: 'Mô tả:',
    TeacherShortCut: 'GV. ',
    CalendarEmpty: 'Chưa có lịch học',
    UrlNotFound: 'Đường dẫn không tồn tại',
    SupportDescription:
      'Em hãy điền chính xác họ tên <br/> <b>{UserName}</b> <br/> trên {OnlineMeeting} để Thầy/Cô điểm danh nhé!',
    ButtonJoinClass: 'Sao chép Họ tên và Tiếp tục',
    CopyUserName: 'Sao chép thành công'
  }
}
